import React, { useState, useEffect, useRef } from 'react';
import { IconButton, Icon, TextField, FormHelperText, Button, Tooltip } from '@mui/material';

interface AnnotationFormProps {
  parentId: string;
  onSubmit: (text: string) => void;
  initialValue?: string;
}

const MAX_LENGTH = 2000;

const AnnotationForm: React.FC<AnnotationFormProps> = ({ 
  parentId, 
  onSubmit,
  initialValue = ''
}) => {
  const [text, setText] = useState('');
  const [charCount, setCharCount] = useState(0);
  const [error, setError] = useState<string | null>(null);
  const textareaRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    setText(initialValue);
    setCharCount(initialValue.length);
    setError(null);
  }, [initialValue, parentId]);

  const handleChange = (value: string) => {
    setText(value);
    setCharCount(value.length);
  
    if (value.length > MAX_LENGTH) {
      setError('Opmerking mag maximaal 2000 tekens bevatten');
    } 
    else {
      setError(null);
    }
  };

  const handleSubmit = () => {
    if (!text.trim()) {
      setError('Opmerking is verplicht');
      return;
    }
    if (text.length > MAX_LENGTH) {
      setError('Opmerking mag maximaal 2000 tekens bevatten');
      return;
    }

    onSubmit(text.trim());
    setText('');
    setCharCount(0);
  };

  return (
    <div className="annotation-form">
      <div className="input-row">
        <TextField
          variant="standard"
          placeholder="Voeg een opmerking toe..."
          fullWidth
          multiline
          value={text}
          onChange={(e) => handleChange(e.target.value)}
          InputProps={{ disableUnderline: true }}
          inputRef={textareaRef}
          minRows={1}
          maxRows={6}
          className="input-field"
        />
        <Tooltip title="Opmerking opslaan" arrow>
          <IconButton
            color="secondary"
            onClick={handleSubmit}
            // disabled={!text.trim()}
            className="send-btn"
          >
            <Icon>send</Icon>
          </IconButton>
        </Tooltip>
        
      </div>

      <div className="form-meta">
        <FormHelperText className={`error-text ${error ? 'visible' : ''}`}>
          {error || ''}
        </FormHelperText>

        <FormHelperText
          className={`char-count ${charCount >= MAX_LENGTH ? 'error' : ''}`}
        >
          {charCount} / {MAX_LENGTH}
        </FormHelperText>
      </div>


    </div>
  );
};

export default AnnotationForm;
